module.exports = __webpack_public_path__ + "img/lightclient.cce1936b.jpg";